import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import styled from "styled-components";
import styles from "../Styles/AboutUs.css";
import aboutUsImage from "../Assets/ablogo.png"; // Ensure the path to your image is correct
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faInstagram,
  faYoutube,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

const AboutUsContainer = styled.section`
  background: linear-gradient(135deg, #f9f9ff 0%, #f0f0ff 100%);
  padding: 80px 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${aboutUsImage}) no-repeat;
    background-position: right -100px center;
    background-size: contain;
    opacity: 0.1;
    z-index: 0;
  }
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  z-index: 1;

  h2 {
    font-size: 2.8rem;
    color: #483285;
    font-weight: 700;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;

    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 4px;
      background: linear-gradient(90deg, #8a63d2 0%, #483285 100%);
      border-radius: 2px;
    }
  }

  p {
    font-size: 1.2rem;
    color: #6c757d;
    max-width: 700px;
    margin: 0 auto;
  }
`;

const StyledCard = styled(Card)`
  border: none;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(72, 50, 133, 0.1);
  margin-bottom: 30px;
  transition: all 0.3s ease;
  background-color: white;
  position: relative;
  z-index: 1;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(72, 50, 133, 0.15);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    background: linear-gradient(to bottom, #8a63d2, #483285);
  }

  .card-body {
    padding: 30px;
  }

  .card-title {
    font-size: 1.8rem;
    color: #483285;
    font-weight: 600;
    margin-bottom: 20px;
    position: relative;
    padding-bottom: 15px;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 50px;
      height: 3px;
      background: linear-gradient(90deg, #8a63d2 0%, #483285 100%);
      border-radius: 2px;
    }
  }

  .card-text {
    font-size: 1.1rem;
    color: #555;
    line-height: 1.7;
  }

  ul {
    padding-left: 20px;
    li {
      margin-bottom: 10px;
      position: relative;
      padding-left: 25px;

      &::before {
        content: "•";
        position: absolute;
        left: 0;
        color: #8a63d2;
        font-weight: bold;
        font-size: 1.5rem;
        line-height: 1;
      }

      strong {
        color: #483285;
      }
    }
  }
`;

const BrandImage = styled.div`
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;

  img {
    max-width: 100%;
    height: auto;
    border-radius: 15px;
    box-shadow: 0 15px 30px rgba(72, 50, 133, 0.2);
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.03);
    }
  }
`;

const ContactUsWrapper = styled.div`
  width: 90%;
  margin: 40px auto 0;
  display: flex;
  justify-content: center;
  padding: 20px;
  position: relative;
  z-index: 1;

  a {
    background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
    color: white;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 5px 15px rgba(18, 140, 126, 0.4);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(18, 140, 126, 0.6);
    }
  }
`;

const phoneNumber = "9647744052020";

const AboutUs = () => {
  return (
    <AboutUsContainer id="about-us">
      <Container>
        <SectionHeader>
          <h2>About Us</h2>
          <p>Discover our story, mission, and values that drive our innovation in medical aesthetics</p>
        </SectionHeader>
        
        <Row className="align-items-center">
         
          
          <Col lg={7}>
            <StyledCard>
              <Card.Body>
                <Card.Title>Our Vision</Card.Title>
                <Card.Text>
                  At Epilyum, we envision a world where advanced medical aesthetic
                  technology redefines beauty and wellness. We are committed to
                  innovation, delivering breakthrough technology solutions that
                  empower professionals and enhance patient confidence. By
                  blending science with sophistication, we aim to be the global leader
                  in medical aesthetic devices, setting new standards in safety,
                  efficacy, and comfort.
                </Card.Text>
              </Card.Body>
            </StyledCard>
            
            <StyledCard>
              <Card.Body>
                <Card.Title>Our Mission</Card.Title>
                <Card.Text>
                  We strive to revolutionize the medical aesthetic industry with next
                  generation technology that delivers superior results and an
                  exceptional user experience. Our mission is to develop high-
                  performance devices that are safe, effective, and designed for all
                  skin and hair types. With innovation at our core, we continuously
                  push the boundaries of medical aesthetics, empowering
                  practitioners and transforming patient care.
                </Card.Text>
              </Card.Body>
            </StyledCard>
            
            <StyledCard>
              <Card.Body>
                <Card.Title>Our Values</Card.Title>
                <Card.Text>
                  <ul>
                    <li>
                      <strong>Integrity:</strong> We uphold the highest
                      standards of integrity in all of our actions.
                    </li>
                    <li>
                      <strong>Customer Focus:</strong> Our customers are at the
                      heart of everything we do.
                    </li>
                    <li>
                      <strong>Innovation:</strong> We foster a culture of
                      creativity and innovation.
                    </li>
                    <li>
                      <strong>Quality:</strong> We are committed to excellence
                      in everything we undertake.
                    </li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </StyledCard>
          </Col>
        </Row>
        
        <ContactUsWrapper>
          <a
            href={`https://wa.me/${phoneNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-icon"
            aria-label="Contact us via WhatsApp"
          >
            <FontAwesomeIcon icon={faWhatsapp} size="2x" />
          </a>
        </ContactUsWrapper>
      </Container>
    </AboutUsContainer>
  );
};

export default AboutUs;